import { Injectable } from '@angular/core';
import type { Inputfiledsbase } from '../../../../models/inputfiledsbase';
import { TextboxQuestion } from '../../../../question-textbox';
import { TextareaQuestion } from '../../../../question-textarea';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddstaffassignmentService {
  getStaffAssignmentsQuestion() {
    const questions: Inputfiledsbase<string>[] = [
      new TextboxQuestion({
        key: 'assignment_title',
        label: 'Assignment Title',
        required: true,
        order: 1,
      }),
      new TextareaQuestion({
        key: 'additional_info',
        label: 'Additional Information',
        required: true,
        order: 2,
      }),
    ];

    // Wrap the array into an Observable
    return of(questions.sort((a, b) => a.order - b.order));
  }
}
